import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Colors from "../utils/colors";
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AustraliaIcon from '../icons/Australia';
import CoalIcon from '../icons/Coal';
import CorporateIcon from '../icons/Corporate';
import ETMIcon from '../icons/ETM';
import GasIcon from '../icons/Gas';
import HydroIcon from '../icons/Hydro';
import SharedServicesIcon from '../icons/SharedServices';
import WindIcon from '../icons/Wind';

const iconMap = {
  'Coal': CoalIcon,
  'Mining': CoalIcon,
  'Australia': AustraliaIcon,
  'Gas': GasIcon,
  'Hydro': HydroIcon,
  'Wind/Solar': WindIcon,
  'ETM': ETMIcon,
  'Corporate': CorporateIcon,
  'Shared Services': SharedServicesIcon
};

const useStyles = makeStyles(( theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: props => ({
    flex: 1,
    cursor: 'pointer',
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
    backgroundColor: props.selected ? Colors.secondary : Colors.primary,
    textAlign: 'center',
    height: '9rem'
  }),
  typography: {
    color: 'white',
    padding: '1rem'
  },
  sharedServiceTypography: {
    color: 'white',
    lineHeight: '0.8',
    padding: '0.8rem'
  },
  buIcon: {
    width: '56px',
    height: '56px',
    textAlign: 'center'
  }
}));

export default function BUPaper({ name, selected, onClick }) {
  const BUIcon = iconMap[name];
  const classes = useStyles({ selected });
  return (
    <Paper className={classes.paper} onClick={onClick} elevation={3}>
      <Typography variant="h5" component="h3" align={'center'} className={name === 'Shared Services' ? classes.sharedServiceTypography : classes.typography}>
        {name}
      </Typography>
      {BUIcon && <BUIcon className={classes.buIcon}/>}
    </Paper>
  );
}

BUPaper.propTypes = {
  bgcolor: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};
